// tslint:disable-next-line:class-name fixme will fix this later as this involves checking js outside of exo.ts
import { Socket } from "socket.io-client";

export default class globals {
    static tokenKey: string = "token";
    static splashIntervalId: any = null;
    static firstDataBound: boolean = false;
    static currentMainTab: string = "";
    static checkedIds: any = {};
    static primaryId: any = "";
    static magicFlag: boolean = true;
    static gridState: any = "";

    static user: any = 0;
    static selectedDocuments: any = {};
    static selectedDocumentsEx: any = {};
    static gridToPageOne: boolean = false;
    static documentViewer: any = {};
    static initialBigFilterApplied: boolean = false;
    static targetGrid: any;
    static showSelectedSelection: object = {};

    static dossierIdList: any = null;
    // public static allowFilterViewRedraw: any = true;
    static gridCleared: any;
    // public static userList: any;
    static assocGridSelection: any;
    static assocGridExSelection: any;

    static gridCallbackIntervalIds: any = {};
    static lastSelectionIsSingular: boolean;
    static selectedProjectDocuments: any;
    static selectedProjectDocumentsEx: any;

    // Sample socket
    static tagBrowserSocket: Socket = null;
}
